import React from 'react';

/**
 * A simple, reusable component to display a loading spinner and a message.
 * @param {object} props - The properties passed to the component.
 * @param {string} props.message - The message to display below the spinner.
 * @returns {JSX.Element}
 */
const Loader = ({ message }) => (
    <div className="flex flex-col items-center justify-center my-8">
        <div className="border-8 border-gray-200 border-t-blue-600 rounded-full w-16 h-16 animate-spin"></div>
        <p className="mt-4 text-lg font-medium text-gray-600">{message}</p>
    </div>
);

export default Loader;
